import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["frame"]

  connect() {
    this._onClose = () => {
      if (this.hasFrameTarget) this.frameTarget.innerHTML = ""
    }
    this.element.addEventListener("close", this._onClose)

    this._observer = new MutationObserver(() => {
      if (this.hasFrameTarget && this.frameTarget.innerHTML.trim() === "" && this.element.open) {
        this.element.close()
      }
    })

    if (this.hasFrameTarget) {
      this._observer.observe(this.frameTarget, { childList: true })
    }
  }

  disconnect() {
    this.element.removeEventListener("close", this._onClose)
    this._observer?.disconnect()
  }

  opened() {
    if (!this.element.open) this.element.showModal()
  }

  close() {
    this.element.close()
  }
}
